// extracted by mini-css-extract-plugin
export var pHeaderMenuLogged = "Zf";
export var lHeader__menuLogged = "_f";
export var aLogoLovePeace1 = "ag";
export var aLogoLovePeace2 = "bg";
export var aButton1 = "cg";
export var aButton2 = "dg";
export var aButton3 = "eg";
export var aButton4 = "fg";
export var aButton5 = "gg";
export var aButtonHeaderLogin = "hg";
export var aButtonHeaderRegister = "ig";
export var aButtonBig = "jg";
export var aButtonRegister = "kg";
export var aButtonLogin = "lg";
export var aButtonContinuation = "mg";
export var icon = "ng";
export var aButtonHeaderSpLogin = "og";
export var pHeaderMenu = "pg";
export var pHeaderMenu__item = "qg";
export var pHeaderMenu__itemSp = "rg";
export var pHeaderMenu__itemPc = "sg";
export var lHeader = "tg";
export var lHeader__inner = "ug";
export var lHeader__right = "vg";
export var lHeader__left = "wg";
export var animationMarquee = "xg";